<template>
  <div class="video">
    <iframe
      :src="videoSrc"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      v-if="isActivated"
    ></iframe>
    <div class="video__preview" v-else @click="activateAndPlay">
      <img :src="preview" class="video__preview-image" alt="Превью" />
      <button class="video__play"><icon name="play" /></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Video",

  props: {
    videoSrc: {
      type: String,
      default: ""
    },
    preview: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      isActivated: false
    };
  },

  methods: {
    activateAndPlay() {
      this.isActivated = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";

.video {
  position: relative;

  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);

  &__preview {
    position: relative;

    background: #005197;

    width: 100%;
    height: 100%;

    cursor: pointer;

    &-image {
      width: 100%;
      height: 100%;

      object-fit: cover;
      display: block;
    }
  }

  &__play {
    @include centerAbsolutely();

    width: 60px;
    height: 40.8px;

    background-color: rgba(#414042, 0.8);

    border: none;

    border-radius: 10px;

    cursor: pointer;

    .svg-icon {
      width: 17px;
      height: 19px;

      @include centerAbsolutely();
    }
  }

  iframe {
    position: absolute;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    width: 100%;
    height: 100%;
  }
}
</style>
